export enum BusinessType {
    UNKNOWN,
    VENUE,
    COACH,
    GROUP,
    EVENTS,
}